import { create } from "zustand";
import { devtools } from "zustand/middleware";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface UserInfo {
  sub: string;
  email?: string;
  name?: string;
}

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  userInfo: UserInfo | null;

  setAuthenticated: (info: UserInfo) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

// ---------------------------------------------------------------------------
// Store
// ---------------------------------------------------------------------------

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      isAuthenticated: false,
      isLoading: true,
      userInfo: null,

      setAuthenticated: (info) => {
        set(
          { isAuthenticated: true, isLoading: false, userInfo: info },
          false,
          "setAuthenticated",
        );
      },

      setLoading: (loading) => {
        set({ isLoading: loading }, false, "setLoading");
      },

      logout: () => {
        set(
          { isAuthenticated: false, isLoading: false, userInfo: null },
          false,
          "logout",
        );
      },
    }),
    { name: "AuthStore", enabled: import.meta.env.DEV },
  ),
);

// ---------------------------------------------------------------------------
// Selectors
// ---------------------------------------------------------------------------

export const selectIsAuthenticated = (s: AuthState) => s.isAuthenticated;
export const selectIsLoading = (s: AuthState) => s.isLoading;
export const selectUserInfo = (s: AuthState) => s.userInfo;
